export function copyToClipboard(targetText) {
    let fakeElem = document.createElement("input");
    fakeElem.style.position = "absolute";
    fakeElem.style.left = "-99999px";
    fakeElem.value = targetText;

    document.body.appendChild(fakeElem);
    fakeElem.select();
    document.execCommand("copy");

    window.getSelection().removeAllRanges();
    document.body.removeChild(fakeElem);
    fakeElem = null;
}
